import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-2d57ad8c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "spoc-course"
};
const _hoisted_2 = {
  class: "link-list"
};
const _hoisted_3 = {
  class: "text"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "btn-text"
}, "更多", -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shouqi1"
}, null, -1));

const _hoisted_6 = {
  class: "show-classify"
};
const _hoisted_7 = {
  class: "classify-box"
};
const _hoisted_8 = ["onClick"];

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-arrow-down"
}, null, -1));

const _hoisted_10 = {
  class: "course-list"
};
const _hoisted_11 = {
  key: 0,
  class: "no-data",
  style: {
    "margin-bottom": "40px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CardHeader = _resolveComponent("CardHeader");

  const _component_CourseCard = _resolveComponent("CourseCard");

  const _component_Empty = _resolveComponent("Empty");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_CardHeader, {
    class: "course-header",
    bodyStyle: {
      background: 'none'
    },
    link: `/courseList.html?type=2&name=${$props.menu.module_name}&menuId=${$props.menu.menu_id}`
  }, {
    left: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString($props.menu.module_name), 1)])]),
    right: _withCtx(() => [_hoisted_4, _hoisted_5]),
    _: 1
  }, 8, ["link"]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
    class: _normalizeClass(["show-list", _ctx.hiddenMoreClass && 'hidden'])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.classifyList, item => {
    return _openBlock(), _createElementBlock("span", {
      class: _normalizeClass(["list-item", $data.classifyId === item.id && 'active']),
      key: item.id,
      onClick: $event => $options.searchCourseList(item.id)
    }, _toDisplayString(item.name), 11, _hoisted_8);
  }), 128))], 2), $data.classifyList.length > 5 ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: _normalizeClass(["show-more-btn", !_ctx.hiddenMoreClass && 'hidden']),
    onClick: _cache[0] || (_cache[0] = $event => _ctx.hiddenMoreClass = !_ctx.hiddenMoreClass)
  }, [_createTextVNode(_toDisplayString(_ctx.hiddenMoreClass ? '展开' : '收起') + " ", 1), _hoisted_9], 2)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_10, [$data.homeCourseList && $data.homeCourseList.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.homeCourseList, course => {
    return _openBlock(), _createBlock(_component_CourseCard, {
      info: course,
      key: course.courseId,
      showDetail: false,
      userInfo: $props.userInfo,
      authType: $data.authType,
      zhsRole: $props.zhsRole,
      classifyId: $data.classifyId
    }, null, 8, ["info", "userInfo", "authType", "zhsRole", "classifyId"]);
  }), 128)) : _createCommentVNode("", true)]), $data.homeCourseList.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_Empty)])) : _createCommentVNode("", true)]);
}